/* eslint-disable @typescript-eslint/no-explicit-any */
export function objectToHash(obj: any): string {
  const str = JSON.stringify(obj);
  let hash = 0;

  for (let i = 0; i < (str?.length ?? 0); i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0; // Converte para 32-bit integer
  }

  return hash.toString(16);
}
